import { WithStyles, withStyles } from '@mui/styles';
import { SortModel } from '@tassat/common-definitions';
import {
    APIConnectionRecord,
    APIConnectionUsersRecord,
    FirmRecord
} from '@tassat/fred-definitions';
import { UserRecordExtended } from '@tassat/fred-extended-definitions';

import { FirmUsers } from './firmUsers';
import { muiStyles } from './firmUsersStyles';

export interface GridUserData extends UserRecordExtended {
    HasApiConnections?: boolean;
}

export type ApiConnectionUsersWithConnection = {
    apiConnectionUser: APIConnectionUsersRecord;
    apiConnection: APIConnectionRecord;
};

export interface IFirmUsersProps extends WithStyles<typeof muiStyles> {
    firm: FirmRecord;
    sortModel: SortModel | null;
}

export default withStyles(muiStyles)(FirmUsers);